import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { getLineStatus } from "../../../../apis/cart/Order/LineStatus";
import { CreateLineStatusHistory } from "../../../../apis/cart/Order/OrderStatusHistory";
import { FormDrawer } from "../../../../components/Form/FormDrawer";
import { showToast } from "../../../../utils/toast";
import { AttemptedForm } from "./AttemptedForm";
import { CancelForm } from "./CancelForm";
import { ConfirmForm } from "./ConfirmForm";
import { DispatchForm } from "./DispatchForm";
import { OutofDeliveryForm } from "./OutofDeliveryForm";
import moment from "moment";
import FormWrapper from "../../../../components/Form/FormWrapper";

export const LineStatusForm = ({ item, handleClose, open }) => {
	const form = useForm({
		defaultValues: {
			old_status: "",
			new_status: "",
		},
	});
	const {
		handleSubmit,
		control,
		watch,
		reset,
		setValue,
		formState: { errors },
	} = form;
	const [dialogOpen, setDialogOpen] = useState(false);
	const [message, setMessage] = useState("");

	const preparePayload = (data) => ({
		...data,
		estimated_arrival_date: data.estimated_arrival_date
			? data.estimated_arrival_date.format("YYYY-MM-DD")
			: null,
		start_time: data.start_time ? data.start_time.format("HH:mm") : null,
		end_time: data.end_time ? data.end_time.format("HH:mm") : null,
		next_delivery_date: data.next_delivery_date
			? data.next_delivery_date.format("YYYY-MM-DD")
			: null,
	});

	const onSubmit = async (data) => {
		// showToast("Product status updated successfully!", "success");
		// handleClose();
		try {
			console.log("Form Data:", data, data.start_date);
			const payload = preparePayload(data);
			console.log("====================================");
			console.log(payload);
			console.log("====================================");

			const res = await CreateLineStatusHistory(item.id, payload);
			if (res.success) {
				if (res.exists) {
					setMessage(res.message);
					setDialogOpen(true);
					// setRefresh(true);
				} else {
					showToast(
						"Product status updated successfully!",
						"success"
					);

					// setOrder((prev) => ({
					// 	...prev,
					// 	status_history: [...(prev.status_history || []), res],
					// 	status: formdata.new_status,
					// }));

					handleClose();
				}
			} else {
				showToast(
					res.message ||
					"Failed to update product status. Please try again.",
					"error"
				);
				// setDialogOpen(false);
			}
		} catch (error) {
			console.error("Failed to update product status:", error);
			showToast("Something went wrong. Please try again.", "error");
			setDialogOpen(false);
		} finally {
			setLoading(false);
			// Add any cleanup here if needed later
		}
	};
	const watch_status = watch("new_status");

	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState([]);

	useEffect(() => {
		if (!watch_status) {return;}

		const newDefaults = {
			old_status: item?.status || "",
			new_status: watch_status,
		};

		if (watch_status === "Dispatched") {
			newDefaults.estimated_arrival_date = moment().add(7, "days");
		}

		if (watch_status === "Out for Delivery") {
			newDefaults.tracking_url = item?.tracking_url || "";
			newDefaults.tracking_number = item?.tracking_number || "";
		}

		if (watch_status === "Delivery Attempted") {
			newDefaults.next_delivery_date = moment().add(1, "days");
		}

		reset(newDefaults);
	}, [
		item?.status,
		item?.tracking_number,
		item?.tracking_url,
		reset,
		watch_status,
	]);

	useEffect(() => {
		const loadStatus = async () => {
			if (!open) {return;}

			reset();
			setLoading(true);
			setValue("old_status", item?.status);
			let stage = "dispatched";
			if (item?.status.toLowerCase() === "dispatched") {
				stage = "out-delivery";
			} else if (
				item?.status.toLowerCase() === "out for delivery" ||
				item?.status.toLowerCase() === "delivery attempted"
			) {
				stage = "delivery";
			}
			const res = await getLineStatus(10, 1, { stage });
			setStatus(res.results);
			setLoading(false);
		};

		loadStatus();
	}, [item?.status, open, reset, setValue]);

	return (
		<FormDrawer open={open} setEditOpen={handleClose} loading={loading}>
			<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
				<Typography color={"primary"} variant="h4">
					Product Status
				</Typography>
				<Box my={3}>
					<FormControl fullWidth error={Boolean(errors.new_status)}>
						<InputLabel id="order-status-label">Status</InputLabel>
						<Controller
							// defaultValue={""}
							name="new_status"
							rules={{ required: "Select Status" }}
							control={control}
							render={({ field }) => (
								<Select
									labelId="order-status-label"
									id="order-status"
									// value={age}
									{...field}
									value={field.value ?? ""}
									label="Status"
								// onChange={handleChange}
								>
									{status?.map((stat, i) => (
										<MenuItem
											value={stat.name}
											key={`status-${i}`}
										>
											{stat.name}
										</MenuItem>
									))}
								</Select>
							)}
						/>
						{errors.new_status && (
							<FormHelperText>
								{errors.new_status?.message}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
				<Box my={3}>
					{watch_status === "Cancelled" && <CancelForm form={form} />}
					{watch_status === "Confirmed" && (
						<ConfirmForm form={form} />
					)}
					{watch_status === "Out for Delivery" && (
						<OutofDeliveryForm form={form} item={item} />
					)}
					{watch_status === "Dispatched" && (
						<DispatchForm form={form} />
					)}
					{watch_status === "Delivery Attempted" && (
						<AttemptedForm form={form} />
					)}
				</Box>
				<Box my={3}>
					<Button type="submit" fullWidth variant="contained">
						Update Status
					</Button>
				</Box>
			</FormWrapper>

			<Dialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setDialogOpen(false)} autoFocus>
						Okay
					</Button>
				</DialogActions>
			</Dialog>
		</FormDrawer>
	);
};
